// Sidebar del Portal Admin VentasLuga, calcado de `surekeep/mockups/backoffice/portal-admin-vl*.html` (main).
// Cada item declara su `permission`; el AppShell esconde lo que el rol no tiene (fail-closed).
import { linkOptions } from '@tanstack/react-router';
import {
    AlertTriangle,
    ArrowLeftRight,
    ClipboardList,
    CreditCard,
    DollarSign,
    Home,
    LineChart,
    Package,
    Star,
    Store,
    User,
    Users,
} from 'lucide-react';
import type { AppShellNavGroup } from '@/shared/patterns/AppShell';
import { RETAILER_TRANSFER_NOTE_PERMISSIONS } from '@/domains/transferNotes/permissions';

export const RETAIL_ADMIN_PORTAL_TITLE = 'Portal Admin VentasLuga';

// Sin `status` el item cae a 'stub' y se pinta atenuado como «En construcción»; declararlo siempre.

const section = (slug: string) =>
    linkOptions({ to: '/retail-admin/$section', params: { section: slug } });

export const retailAdminNav: AppShellNavGroup[] = [
    {
        items: [
            {
                label: 'Home',
                icon: Home,
                link: linkOptions({ to: '/retail-admin' }),
                exact: true,
                permission: 'retail.admin.home.read',
                status: 'connected',
            },
        ],
    },
    {
        label: 'Catálogo',
        items: [
            {
                slug: 'clientes',
                label: 'Clientes',
                icon: Users,
                link: section('clientes'),
                permission: 'retail.customer.list',
                status: 'connected',
            },
            {
                slug: 'vendedores',
                label: 'Vendedores',
                icon: User,
                link: section('vendedores'),
                permission: 'retail.seller.kpis.read',
                status: 'connected',
            },
            {
                slug: 'tiendas',
                label: 'Tiendas',
                icon: Store,
                link: section('tiendas'),
                permission: 'retail.store.kpis.read',
                status: 'connected',
            },
            {
                slug: 'inventario',
                label: 'Inventario',
                icon: Package,
                link: section('inventario'),
                permission: 'retail.inventory.lens.read',
                status: 'connected',
            },
        ],
    },
    {
        label: 'Operación',
        items: [
            {
                slug: 'ventas',
                label: 'Ventas Hechas',
                icon: CreditCard,
                pageTitle: 'Ventas · piso completo',
                link: section('ventas'),
                permission: 'retail.sale.read.all',
                status: 'connected',
            },
            {
                slug: 'comisiones',
                label: 'Com. Pagadas',
                icon: DollarSign,
                pageTitle: 'Comisiones pagadas',
                link: section('comisiones'),
                permission: 'retail.commission.payout.read',
                status: 'connected',
            },
            {
                slug: 'analisis',
                label: 'Análisis',
                icon: LineChart,
                link: section('analisis'),
                permission: 'retail.analytics.read',
                status: 'connected',
            },
            {
                slug: 'transferencias',
                label: 'Transferencias',
                pageTitle: 'Transferencias · notas con FSA y SK',
                icon: ArrowLeftRight,
                link: section('transferencias'),
                permission: RETAILER_TRANSFER_NOTE_PERMISSIONS.read,
                status: 'connected',
            },
            {
                slug: 'conciliacion',
                label: 'Conciliación',
                icon: ClipboardList,
                pageTitle: 'Conciliación diaria',
                link: section('conciliacion'),
                permission: 'retail.settlement.reconciliation.read',
                status: 'stub',
            },
            // Fuera del mock: pantallas vivas que siguen en el menú hasta que Jaime les dé lugar.
            {
                slug: 'excepciones',
                label: 'Excepciones',
                icon: AlertTriangle,
                link: section('excepciones'),
                permission: 'retail.exception.list',
                status: 'connected',
            },
        ],
    },
    {
        label: 'Incentivos',
        items: [
            {
                slug: 'promociones',
                label: 'Promos venta',
                icon: Star,
                link: section('promociones'),
                permission: 'retail.promotion.list',
                status: 'connected',
            },
            {
                slug: 'plan-comisiones',
                label: 'Comisiones',
                icon: DollarSign,
                pageTitle: 'Comisiones · motor de reglas',
                link: section('plan-comisiones'),
                permission: 'retail.commission.plan.read',
                status: 'connected',
            },
        ],
    },
    // El grupo «Reportes» (Catálogo de reportes) está oculto por ahora; la pantalla sigue en la ruta.
];
